import request from '@/utils/api_req.js'

export function refreshToken(token) {
  return request.get(`login/refresh/` + token, {}, { noAuth: true })
}

/**
 * 校验token是否有效
 */
export function tokenIsExistApi() {
  return request.post(`login/token/is/exist`, {}, { noAuth: true })
}

/**
 * 文章详情
 * @param int id
 *
 */
export function getArticleDetails(id) {
  return request.get(`article/info/${id}`, {}, { noAuth: true })
}
